import { render } from "./Smokes.vue?vue&type=template&id=64af4c1f&scoped=true"
import script from "./Smokes.vue?vue&type=script&lang=js"
export * from "./Smokes.vue?vue&type=script&lang=js"

import "./Smokes.vue?vue&type=style&index=0&id=64af4c1f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64af4c1f"]])

export default __exports__